import Lenis from 'lenis'

export default function Faq() {
	document.addEventListener('DOMContentLoaded', function () {
		const faqItems = document.querySelectorAll('.faq-item')

		// 🔥 Garante que Lenis seja inicializado apenas uma vez
		if (!window.lenis) {
			window.lenis = new Lenis()
			function raf(time) {
				window.lenis.raf(time)
				requestAnimationFrame(raf)
			}
			requestAnimationFrame(raf)
		}

		const lenis = window.lenis

		faqItems.forEach((item) => {
			item.addEventListener('click', function () {
				const isVisible = this.classList.contains('visible')
				const openItem = document.querySelector('.faq-item.visible')

				if (openItem && openItem !== this) {
					const openContent = openItem.querySelector('.faq-content')
					openItem.classList.remove('visible')

					// Aguarda a transição do fechamento antes de abrir a nova
					openContent.addEventListener(
						'transitionend',
						() => {
							if (!isVisible) {
								openContent.style.maxHeight = '0px'
								openItem.classList.remove('visible') // Fecha completamente

								// Aguarda um frame para evitar jumps
								requestAnimationFrame(() => {
									this.classList.add('visible')
									const newContent = this.querySelector('.faq-content')
									newContent.style.maxHeight = newContent.scrollHeight + 200 + 'px'

									// 🔥 Espera um pouco antes de ativar o scroll
									setTimeout(() => {
										scrollToElement(this)
									}, 300)
								})
							}
						},
						{ once: true }
					)
				} else {
					this.classList.toggle('visible')
					const content = this.querySelector('.faq-content')
					if (isVisible) {
						content.style.maxHeight = '0px' // Fecha
					} else {
						content.style.maxHeight = content.scrollHeight + 200 + 'px' // Abre suavemente

						// 🔥 Espera um pouco antes de ativar o scroll
						setTimeout(() => {
							scrollToElement(this)
						}, 300)
					}
				}
			})
		})

		// 🔥 Função que faz o scroll para a pergunta aberta
		function scrollToElement(element) {
			const headerOffset = 100 // Ajuste conforme necessário
			const elementPosition = element.getBoundingClientRect().top + window.scrollY
			const offsetPosition = elementPosition - headerOffset

			// Se Lenis estiver ativo, usa ele
			if (lenis) {
				lenis.scrollTo(offsetPosition, { duration: 1 })
			} else {
				window.scrollTo({ top: offsetPosition, behavior: 'smooth' })
			}
		}
	})
}
